import * as React from 'react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { TextFieldWithFullscreen } from './TextFieldWithFullscreen'

type UserPermissionsProps = TextFieldProps & {
  permissions: string[] | null | string
}

const inputProps = {
  readOnly: true,
}

export const UserPermissions: React.FunctionComponent<UserPermissionsProps> = ({
  permissions,
  ...rest
}) => {
  const safePermissions =
    permissions === null
      ? []
      : Array.isArray(permissions)
      ? permissions
      : [permissions]
  const permissionsString = safePermissions.join(', ')

  return (
    <TextFieldWithFullscreen
      value={permissionsString}
      label="Permissions"
      isCommaDelimited
      multiline
      fullWidth
      rows={5}
      inputProps={inputProps}
      {...rest}
    />
  )
}
